import { IconButton, MenuItem, TableCell, TableRow, TextField, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { UseFormReturn } from "react-hook-form";
import { formatCurrency } from "../../../utils/formatCurrency";
import { ReactNode } from "react";

type PaymentRowProps = {
    payment: any;
    index: number;
    paymentMethodField: any;
    amountField: any;
    choices: Array<any>;
    entityForm?: UseFormReturn;
    isReadOnly: boolean;
    onDelete?: (index: number) => void;
    bankTransactionCell?: ReactNode;
    deleteLockedReason?: string;
};

export const PaymentRow = ({
    payment,
    index,
    paymentMethodField,
    amountField,
    choices,
    entityForm,
    isReadOnly,
    onDelete,
    bankTransactionCell,
    deleteLockedReason,
}: PaymentRowProps) => {
    if (isReadOnly) {
        const selectedChoice = choices.find((c: any) => c.value === payment.payment_method);

        return (
            <TableRow>
                <TableCell>{payment.payment_date || "-"}</TableCell>
                <TableCell>{selectedChoice?.text || payment.payment_method || "-"}</TableCell>
                <TableCell>{formatCurrency(payment.amount || 0)}</TableCell>
                <TableCell>{bankTransactionCell}</TableCell>
            </TableRow>
        );
    }

    return (
        <TableRow>
            <TableCell>
                <TextField
                    fullWidth
                    size="small"
                    type="date"
                    {...(entityForm && entityForm.register(`order_payments.${index}.payment_date`))}
                    value={payment?.payment_date || ""}
                    onChange={(e) => entityForm?.setValue(`order_payments.${index}.payment_date`, e.target.value)}
                    variant="outlined"
                />
            </TableCell>

            <TableCell>
                <TextField
                    select
                    fullWidth
                    size="small"
                    label={paymentMethodField.headerName}
                    {...(entityForm && entityForm.register(`order_payments.${index}.payment_method`))}
                    value={payment?.payment_method || ""}
                    onChange={(e) => entityForm?.setValue(`order_payments.${index}.payment_method`, e.target.value)}
                    variant="outlined"
                >
                    {choices.map((choice: any) => (
                        <MenuItem key={choice.value} value={choice.value}>
                            {choice.text}
                        </MenuItem>
                    ))}
                </TextField>
            </TableCell>

            <TableCell>
                <TextField
                    fullWidth
                    size="small"
                    type="number"
                    label={amountField.headerName}
                    {...(entityForm && entityForm.register(`order_payments.${index}.amount`))}
                    value={payment?.amount || 0}
                    onChange={(e) => entityForm?.setValue(`order_payments.${index}.amount`, Number(e.target.value))}
                    variant="outlined"
                    inputProps={{
                        step: 0.01,
                    }}
                />
            </TableCell>

            <TableCell align="right">
                <Tooltip title={deleteLockedReason ?? ""}>
                    <span>
                        <IconButton
                            aria-label="Remover pagamento"
                            onClick={() => onDelete?.(index)}
                            color="error"
                            size="small"
                            disabled={deleteLockedReason !== undefined}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </span>
                </Tooltip>
            </TableCell>
        </TableRow>
    );
};

